import { render, staticRenderFns } from "./thicknessform.vue?vue&type=template&id=bfc15024&"
import script from "./../../ts/dialog/thicknessform.ts?vue&type=script&lang=js&"
export * from "./../../ts/dialog/thicknessform.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports